const ProductDetailActionTypes = {
  TOGGLE_MODAL_HIDDEN: "TOGGLE_MODAL_HIDDEN",
  UPDATE_PRODUCT: "UPDATE_PRODUCT",
};

export default ProductDetailActionTypes;
